/*
 * @Author: guanxiaoyan guanxiaoyan@pb-station.com
 * @Deion:
 * @Date: 2023-06-08 11:06:00
 * @LastEditors: guanxiaoyan guanxiaoyan@pb-station.com
 * @LastEditTime: 2023-06-08 11:29:44
 * @FilePath: /ywx-open/vue/src/api/welcome.js
 */
import Vue from 'vue'
import VueCookies from 'vue-cookies'
import API from '@szyx/axios'
Vue.use(VueCookies)
/** *************** 3代理商和4代理商销api (没有环境切换)************************************ */
const envApi = VueCookies.get('envApi')

export default {
  // 预警统计数量
  getPackageWarningTotal: (params) =>
    API.GET(`/${envApi}/firm/getPackageWarningTotal`, params),
  // 获取销售人员
  getSaleListApiByWelcome: (params) =>
    API.POSTJSON(`/${envApi}/agent/sale/list`, params),
  // 获取销售人员 :接口错误
  getSaleList: () =>
    API.GET(`/${envApi}/tms-admin/api/sys/user/salePersonList`, {}),
  // 客户组列表
  getFirmGroupList: () =>
    API.POSTJSON(`/${envApi}/tms-admin/api/firm/getFirmGroupPage`, {}),
  // 预警列表数据
  getPackageWarningPage: () =>
    API.POSTJSON(`/${envApi}/tms-admin/api/firm/getPackageWarningPage`, {}),
  // 提醒接口
  sendWarningEmail: (params) =>
    API.GET(`/${envApi}/tms-admin/api/firm/sendPackageWarningEmail`, params),
  // 导出接口
  exportPackageWarning: (params) =>
    API.POSTJSON(`/${envApi}/tms-admin/api/firm/exportPackageWarning`, params, {
      responseType: 'blob',
    }),
}
